'use client'

import React, { type ReactNode, useState } from 'react'

import { Coupon, Studio } from '@definitions/types/symfonyTypes'

import { CampaignPopup } from '@definitions/types/storyblokTypes'

import { cn } from '@helper/utils/cn'

import { CouponDialog } from '../CouponDialog'
import { CouponForm } from '../CouponForm'

interface CouponItemProps {
  children: ReactNode
  formId: string
  coupon: Coupon
  studio: Studio
  themeKey?: 'sunpoint' | 'wellmaxx'
  className?: string
  isEligible?: boolean
  campaignPopup?: CampaignPopup
}

export function CouponItem({
  children,
  formId,
  coupon,
  studio,
  themeKey,
  className,
  isEligible = false,
  campaignPopup,
}: CouponItemProps) {
  const [showForm, setShowForm] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false)

  const shouldShowPopup =
    isEligible && campaignPopup?.active === true

  const handleClick = () => {
    // Don't do anything if form is already shown
    if (showForm) {
      return
    }

    if (shouldShowPopup) {
      setDialogOpen(true)
    } else {
      setShowForm(true)
    }
  }

  const handleDialogClose = (open: boolean) => {
    setDialogOpen(open)
    // When dialog closes, show the inline form
    if (!open && shouldShowPopup) {
      setShowForm(true)
    }
  }

  return (
    <>
      <div
        onClick={showForm ? undefined : handleClick}
        className={cn(
          'rounded-2xl',
          'flex flex-col relative overflow-hidden',
          !showForm && 'hover:cursor-pointer',
          'h-fit',
          'border border-solid border-[#d8d8d8]',
          className
        )}
      >
        {showForm ? (
          <CouponForm
            formId={formId}
            onClose={() => setShowForm(false)}
            coupon={coupon}
            studio={studio}
            themeKey={themeKey}
          />
        ) : (
          <div className="flex">
            {children}
          </div>
        )}
      </div>

      {shouldShowPopup && campaignPopup && (
        <CouponDialog
          open={dialogOpen}
          onOpenChange={handleDialogClose}
          campaignPopup={campaignPopup}
        />
      )}
    </>
  )
}
